import { render, staticRenderFns } from "./SwitchSolicitarTokenValidacao.vue?vue&type=template&id=ecfff346&scoped=true"
import script from "./SwitchSolicitarTokenValidacao.vue?vue&type=script&lang=js"
export * from "./SwitchSolicitarTokenValidacao.vue?vue&type=script&lang=js"
import style0 from "./SwitchSolicitarTokenValidacao.vue?vue&type=style&index=0&id=ecfff346&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfff346",
  null
  
)

export default component.exports